import { FC } from 'react';

import { Box, theme } from '@olist/united';

type ContainerProps = { [key: string]: unknown };

export const Container: FC<ContainerProps> = (props) => (
  <Box maxWidth={theme.maxContainerWidth} mx="auto" px={4} py={4} width={1} {...props} />
);
